<template>
  <div class="login-title">
    <span :class="{active:type==1}" @click="toChange(1)">{{typeName1}}</span>
    <span :class="{active:type==2}" @click="toChange(2)">{{typeName2}}</span>
  </div>
</template>
  <script>
export default {
  components: {},
  props:{
    typeName1:{
      type: String,
      default: '手机号登录'
    },
    typeName2:{
      type: String,
      default: '账号登录'
    }
  },
  data() {
    return {
      type:1,
    };
  },
  mounted() {},
  methods: {
    toChange(val){
      this.type = val;
      this.$emit('update:type',val);    
    }
  },
};
</script>
  <!--声明语言，并且添加scoped-->
  <style scoped>
.login-title span {
  position: relative;
  font-size: 18px;
  color: #666;
  font-weight: 700;
  margin-right: 66px;
  padding: 15px 0;
  display: inline-block;
  background-color: #fff;
  cursor:pointer;
}
.login-title .active::after {
  position: absolute;
  content: " ";
  bottom: -2px;
  left: 10%;
  right: 0;
  width: 80%;
  height: 2px;
  background-color: #2655ae;
}
.login-title {    
  padding-bottom: 30px;
}
.login-title .active{
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/user/LoginTitle.vue